export function applyPaymentsToSchedule(schedule, payments) {
  return schedule.map((cuota) => {
    const pago = payments.find((p) => p.installment === cuota.cuota);
    return {
      ...cuota,
      payment: !!pago,
      paymentInfo: pago || null,
    };
  });
}
